<template>
  <div class="price-content">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="型号" prop="productModel">
          <el-input v-model="searchForm.productModel" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="SPU名称" prop="spuName">
          <el-input v-model.trim="searchForm.spuName" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="紧急程度" prop="emergency">
          <el-select v-model="searchForm.emergency" placeholder="全部" clearable @change="onSearch">
            <el-option label="紧急" value="1"></el-option>
            <el-option label="不紧急" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整备注" prop="adjustRemark">
          <el-input v-model.trim="searchForm.adjustRemark" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="调整时间">
          <form-date-range :form="searchForm" startKey="adjustDateStart" endKey="adjustDateEnd" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>

    <el-row class="tabs-row">
      <el-col :span="10">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs">
          <template v-if="storeTabs.length">
            <el-tab-pane
              v-for="(tab, index) in storeTabs"
              :key="index"
              :label="tab.label + ' ' + tab.count"
              :name="tab.name"
              :disabled="loading && tab.name != activeTab"
            ></el-tab-pane>
          </template>
          <div v-else class="occupy"></div>
        </el-tabs>
      </el-col>
      <el-col :span="14" class="table-btn-area">
        <el-button type="primary" size="mini" :disabled="!storeTabs.length" @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>
    <table-panel ref="tablePanel">
      <vxe-table
        ref="multipleTable"
        :data="tableData.list"
        border
        stripe
        :height="maxTableHeight"
        v-loading="loading"
        @checkbox-change="handleSelectionChange"
        @checkbox-all="handleSelectionChange"
      >
        <vxe-column type="checkbox" width="55"></vxe-column>
        <vxe-column field="emergency" title="紧急程度" width="80"></vxe-column>
        <vxe-column field="productModel" title="型号" min-width="120"></vxe-column>
        <vxe-column field="spuName" title="SPU名称" width="200" show-overflow></vxe-column>
        <vxe-column field="noticeTime" title="通知时间" width="160"></vxe-column>
        <vxe-column field="picAdjustType" title="设计图调整类型" min-width="170">
          <template #default="{ row }">
            <el-tooltip effect="dark" placement="top">
              <div slot="content" style="white-space: pre-line;">{{ formatAdjustType(row.picAdjustType) }}</div>
              <div class="multiline-cell-text">{{ formatAdjustType(row.picAdjustType) }}</div>
            </el-tooltip>
          </template>
        </vxe-column>
        <vxe-column field="adjustDetailDesc" title="设计图详情" width="100">
          <template #default="{ row }">
            <el-button v-if="row.adjustDetailDesc && row.adjustDetailDesc.length" size="mini" type="text" @click="viewImg(row.adjustDetailDesc)">
              查看
            </el-button>
          </template>
        </vxe-column>
        <vxe-column field="adjustRemark" title="调整备注" min-width="200"></vxe-column>
        <vxe-column field="sliceUrl" title="切片地址" min-width="200" show-overflow>
          <template #default="{ row }">
            <span v-copy="row.sliceUrl" style="color: #0bb78e; cursor: pointer">
              {{ row.sliceUrl }}
            </span>
          </template>
        </vxe-column>
        <vxe-column field="name" title="调整人" width="80"></vxe-column>
        <vxe-column field="creationDate" title="调整时间" width="160"></vxe-column>
        <vxe-column field="operType" title="操作类型" min-width="80" show-overflow></vxe-column>
        <vxe-column field="operName" title="操作人" min-width="80" show-overflow></vxe-column>
        <vxe-column field="lastUpdateDate" title="操作时间" min-width="150" show-overflow></vxe-column>
      </vxe-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[100, 200, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <appeal-Review :visible.sync="isShowAppealReview" v-if="isShowAppealReview" :appealReason="appealReason" />
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import appealReview from '../../components/appealReview';

export default {
  name: 'PriceContent',
  mixins: [tableMixin, pagePathMixin],
  components: { appealReview },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      selectedRows: [],
      searchForm: {
        productModel: '',
        spuName: '',
        emergency: '',
        adjustRemark: '',
      },
      // 店铺标签页
      activeTab: undefined,
      storeTabs: [],
      reportName: 'waitUp',
      // 图片查看
      isShowAppealReview: false,
      appealReason: '',
    };
  },
  mounted() {
    this.getStroeTab();
  },
  methods: {
    getStroeTab() {
      this.loading = true;
      const data = new FormData();
      data.append('adjustContent', '设计图');
      data.append('status', 1);
      this.$q.newProduct.storeStatics({ data: data }).then((res) => {
        this.storeTabs = res.data.map((v) => ({
          label: v.storeName,
          name: v.storeCode,
          count: v.qty,
        }));
        if (!this.storeTabs || !this.storeTabs.length) {
          this.loading = false;
          this.tableData.total = 0;
          this.tableData.list = [];
          return;
        }
        let tabs = this.storeTabs.map((v) => v.name);
        this.activeTab = this.activeTab == 0 || !tabs.includes(this.activeTab) ? this.storeTabs[0].name : this.activeTab;
        this.$nextTick((_) => {
          this.onSearch();
        });
      });
    },

    handleTabClick() {
      this.onSearch();
    },

    // 处理状态切换
    handleProcessStatusChange() {
      this.tableData.pageNum = 1;
      this.getStroeTab();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let { productModel } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          storeCode: this.activeTab,
          adjustContent: '设计图',
          status: 1,
          productModel: productModel ? productModel.split(' ') : [],
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .msgNoticePage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    onReset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection.records || selection;
    },

    getNewTab() {
      this.$emit('getNumber');
      this.getStroeTab();
    },

    // 导出  path返回为数组json字符 需手动处理
    exportExcel() {
      let _this = this;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.$q.newProduct.exportDesign({ data: this.searchFormData }).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                clearInterval(timer);
                loading.close();
                let file = JSON.parse(res.data.filePath);
                _this.downloadRes(file[0].filePath, file[0].fileName);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName + '' + url.substring(url.lastIndexOf('.'));
      a.click();
      a.remove();
    },

    // 查看图片
    viewImg(appealReason) {
      this.isShowAppealReview = true;
      this.appealReason = appealReason;
    },
    formatAdjustType(value) {
      return value ? String(value).replace(/,/g, '\n') : '';
    },
  },
};
</script>

<style lang="stylus" scoped>
.price-content {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}

.occupy {
  width: 200px;
  height: 20px
}

.table-btn-area {
  text-align: right;
  line-height: 40px;
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

  >>> .form-number-input .el-input-number {
      width: 105px !important;
  }
  >>> .form-number-input .el-input-number .el-input {
      width: 105px !important;
  }

.multiline-cell-text
  white-space pre-line
  word-break break-all
</style>
